import React, { Component } from 'react'

import Button from '../../components/Button/'
import Error from '../../components/Error/'
import { Cross } from '../Icons'
import { Container, Popup, CloseButton, ButtonContainer, Title, Header, Inner } from './styles'
import { white, almostblack, black, lightgray, red } from '../../styles/colors'

class SubmitOrderPopup extends Component {

  async handleSubmit(e) {
    e.preventDefault()
    this.props.submitOrder({ variables: { data: { id: this.props.id, reference: this.props.reference, email: this.props.user.email, firstName: this.props.user.firstName, insertion: this.props.user.insertion ? this.props.user.insertion : '', lastName: this.props.user.lastName, deliveryDate: this.props.deliveryDate, contactCode: this.props.user.contactCode } } })
  }

  render() {
    const { title, confirm, deny, error } = this.props
    if (error) {
      return <Error message={`Fout opgetreden bij het verzenden van uw bestelling met ID: ${this.props.id}`} />
    }

    return (
      <Container>
        <Popup>
          <Inner>
            <Header>
              <Title>{title}</Title>

              <CloseButton onClick={this.props.closePopup}>
                <Cross size="xlarge" />
              </CloseButton>
            </Header>
            <ButtonContainer>
              <Button
                background={red}
                color={white}
                border={red}
                radius="true"
                hover={almostblack}
                hoverColor={white}
                onSubmit={this.handleSubmit.bind(this)}
              >
                {confirm}
              </Button>

              <Button
                background={white}
                color={black}
                border={lightgray}
                radius="true"
                hover={almostblack}
                hoverColor={white}
                onSubmit={this.props.closePopup}
              >
                {deny}
              </Button>
            </ButtonContainer>
          </Inner>
        </Popup>
      </Container>
    )
  }
}

export default SubmitOrderPopup



// WEBPACK FOOTER //
// ./src/components/SubmitOrderPopup/index.js